export default __webpack_public_path__ + "static/media/locationRed.990abc00.svg";